import { verticalNameSelector } from 'ctm-selectors/selectors/base';

/*
 *
 * @param {string} msg
 * @param {string} logLevel - Can be 'INFO', 'WARN', 'ERROR'
 */
export const logToNR = (msg, logLevel) => {
    const nrLicenseKey = process.env.NR_LICENSE_KEY;
    const vertical = verticalNameSelector();
    if (nrLicenseKey) {
        fetch('https://log-api.newrelic.com/log/v1', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Api-Key': nrLicenseKey
            },
            body: JSON.stringify({
                timestamp: Date.now(),
                appId: isNaN(Number(process.env.NR_RUM_APPLICATION_ID)) ? null : Number(process.env.NR_RUM_APPLICATION_ID),
                'entity.guid': process.env.NR_RUM_APPLICATION_GUID,
                env: process.env.EVEREST_DEPLOY_ENV,
                message: msg,
                level: logLevel,
                userAgent: window.navigator.userAgent,
                app_name: `everest:${vertical}`,
                vertical,
                brandCode: process.env.EVEREST_THEME
            })
        });
    }
};
